import React, {Component} from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import axios from 'axios';

import PotentialContentDistributionApiClient from 'js/api_clients/potential_content_distribution_api_client';
import {URLS, ENUMS} from 'js/common';

import PostsLightbox from 'js/components/posts_lightbox';
import AddDistributionButton from './add_distribution_button';
import CancelButton from './cancel_button';
import DistributionPicker from '../distribution_picker_component_zoid';

export default class AddDistributionModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onToggleShown: PropTypes.func.isRequired,
        social_user_id: PropTypes.string,
        campaign_platform_type: PropTypes.string.isRequired
    };

    constructor() {
        super();

        this.state = {
            distributionInProgress: false,
            fetchingRecentMedia: false,
            loadingPosts: false,
            fetchingError: null,
            assignmentError: null,
            recentSocialMediaPosts: [],
            pagination: null
        };
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.show && !this.props.show) {
            this.fetchRecentPosts();
        }
    }

    handleFetchMorePosts = async () => {
        if (this.state.pagination) {
            try {
                this.setState({loadingPosts: true});
                const {
                    data: {data, pagination}
                } = await axios.get(this.state.pagination.next_url);
                const transformedPosts = this.transformPosts(data);
                const newPosts = [...this.state.recentSocialMediaPosts, ...transformedPosts];
                this.setState({loadingPosts: false, recentSocialMediaPosts: newPosts, pagination});
            } catch (error) {
                this.setState({fetchingError: true, loadingPosts: false});
            }
        }
    };

    transformPosts = posts =>
        posts.map(post => ({
            caption: R.pathOr(null, ['caption', 'text'], post),
            mediaUrl: R.pathOr(null, ['images', 'standard_resolution', 'url'], post),
            profilePictureUrl: R.pathOr(null, ['user', 'profile_picture'], post),
            platform: 'instagram',
            username: R.pathOr(null, ['user', 'username'], post),
            postUrl: R.pathOr(null, ['link'], post),
            socialLinkId: R.pathOr(null, ['user', 'username'], post),
            type:
                post.type === ENUMS.ContentType.VIDEO
                    ? ENUMS.ContentType.VIDEO
                    : ENUMS.ContentType.IMAGE
        }));

    onCloseModal = () => {
        const {distributionInProgress} = this.state;
        const {onToggleShown} = this.props;

        if (distributionInProgress) {
            return;
        }

        this.setState({assignmentError: null});

        onToggleShown();
    };

    handlePositionChange = () => {
        this.setState({assignmentError: null});
    };

    /**
     * @param {Object} post
     * @memberof AddDistributionModal
     */
    createPotentialDistribution = async post => {
        try {
            const {content_metadata_id, handleAddPotentialDistribution} = this.props;

            this.setState({distributionInProgress: true});

            // For reels post.mediaUrl is null so this is a fallback for that
            let distribution_content_url = post.mediaUrl;
            if (!distribution_content_url) {
                distribution_content_url = post.postUrl;
            }

            await PotentialContentDistributionApiClient.createPotentialDistribution({
                content_metadata_id,
                created_by_user_id: window.sn.user.id,
                distribution_url: post.postUrl,
                distribution_platform: 'instagram',
                distribution_content_url,
                phash_distance: 0,
                caption: post.caption,
                status: ENUMS.PotentialContentDistributionStatus.PENDING,
                levenshtein_distance: 0
            });

            handleAddPotentialDistribution();
            this.setState({distributionInProgress: false});
            this.onCloseModal();
        } catch (errorResponse) {
            this.setState({
                assignmentError: errorResponse.data || errorResponse,
                distributionInProgress: false
            });
        }
    };

    fetchRecentPosts = async () => {
        try {
            const {social_user_id} = this.props;
            this.setState({fetchingRecentMedia: true, fetchingError: false});
            const {
                data: {posts, pagination}
            } = await axios.get(URLS.recent_social_posts, {
                params: {
                    platform: 'instagram',
                    userId: social_user_id
                }
            });

            this.setState({fetchingRecentMedia: false, recentSocialMediaPosts: posts, pagination});
        } catch (error) {
            this.setState({fetchingError: true, fetchingRecentMedia: false});
        }
    };

    render() {
        const {show} = this.props;
        if (!show) {
            return <div />;
        }

        const {
            fetchingError,
            assignmentError,
            fetchingRecentMedia,
            recentSocialMediaPosts,
            distributionInProgress,
            loadingPosts
        } = this.state;

        if (fetchingRecentMedia) {
            return <div />;
        }

        if (fetchingError) {
            return (
                <PostsLightbox posts={[]} onClose={this.onCloseModal}>
                    <div className="error-message">
                        There was an issue retrieving this creator&quot;s recent media. This is
                        likely due to an issue with the social platform (Instagram, Twitter, etc) or
                        a deployment in progress. Try opening this modal again.
                    </div>
                    <button className="error-button" onClick={this.onCloseModal}>
                        Close
                    </button>
                </PostsLightbox>
            );
        }

        return (
            <PostsLightbox
                handleFetchMorePosts={this.handleFetchMorePosts}
                loadingPosts={loadingPosts}
                posts={recentSocialMediaPosts}
                onClose={this.onCloseModal}
                onPositionChange={this.handlePositionChange}
            >
                <AddDistributionButton
                    distributionInProgress={distributionInProgress}
                    createPotentialDistribution={this.createPotentialDistribution}
                    assignmentError={assignmentError}
                />

                <CancelButton
                    distributionInProgress={distributionInProgress}
                    onCloseModal={this.onCloseModal}
                />
            </PostsLightbox>
        );
    }
}



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/content_row/add_distribution_modal/index.js